import React from 'react';
import { Container, Body5 } from '@ui';
import { ReasoningResultContext, RUNNING_STATUS } from '@/contexts/ReasoningResultContext';
import { AnswerConfigContext } from '@/contexts/AnswerConfigContext';
import { answerFormatter } from '@classes/AnswerFormatter';
import { AnswerBody } from './AnswerBody';

export const ReasoningAnswerReasoning = () => {
  const { enableMoreDetail, enableLinks, ignoreLatex } = React.useContext(AnswerConfigContext);
  const { runningStatus, reasoning } = React.useContext(ReasoningResultContext);

  const formattedAnswer = answerFormatter.formatResult(reasoning, ignoreLatex);

  return (
    <Container>
      {runningStatus === RUNNING_STATUS.ERROR ||
        (runningStatus === RUNNING_STATUS.RETRYING_ERROR && (
          <Container top={24} bottom={24}>
            {runningStatus === RUNNING_STATUS.ERROR ? (
              <Body5 bold>Something went wrong. Answer may be incomplete. Try submitting again.</Body5>
            ) : (
              <Body5 bold>Something went wrong. Reconnecting...</Body5>
            )}
          </Container>
        ))}
      <AnswerBody
        answer={formattedAnswer}
        isStreaming={runningStatus === RUNNING_STATUS.RUNNING}
        enableLinks={enableLinks}
        enableMoreDetail={enableMoreDetail}
        ignoreLatex={ignoreLatex}
      />
    </Container>
  );
};
